"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportChat = void 0;
const models_1 = require("../models");
const mappers_1 = require("../mappers");
class ExportChat {
    constructor(httpAdapter) {
        this.inFlightExports = new Map();
        this.httpAdapter = httpAdapter;
        this._exportChatData = { data: [], limit: 0, total: 0, page: 1 };
    }
    get exportChatData() {
        return this._exportChatData;
    }
    fetchExportChatData(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter
                .getChatAdapter()
                .getExportChats(params, context);
            if (!response.isAborted) {
                this._exportChatData = (0, mappers_1.exportChatsMapper)(response.data);
            }
        });
    }
    initiateExport(exportChatData_1) {
        return __awaiter(this, arguments, void 0, function* (exportChatData, isRetry = false) {
            // Coalesce concurrent identical exports onto one in-flight request, else a
            // double-triggered button fires two byte-identical GETs and
            // DuplicateRequestInterceptor rejects the second with "Panic: duplicate
            // request detected".
            const key = `${exportChatData.exportType}:${exportChatData.chatId}:${isRetry}:${exportChatData.id}`;
            const inFlight = this.inFlightExports.get(key);
            if (inFlight) {
                return inFlight;
            }
            const request = this.initiateExportInternal(exportChatData, isRetry).finally(() => {
                this.inFlightExports.delete(key);
            });
            this.inFlightExports.set(key, request);
            return request;
        });
    }
    initiateExportInternal(exportChatData, isRetry) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                chatId: exportChatData.chatId,
                isRetry,
                exportLogId: exportChatData.id,
            };
            exportChatData.exportType === models_1.EXPORT_TYPE.CHAT
                ? yield this.httpAdapter.getChatAdapter().initiateExportChat(Object.assign(Object.assign({}, params), { offset: this.offset() }))
                : yield this.httpAdapter.getChatAdapter().initiateExportMedia(params);
        });
    }
    offset() {
        try {
            return new Date().getTimezoneOffset();
        }
        catch (error) {
            return -300;
        }
    }
}
exports.ExportChat = ExportChat;
